import { DomHandler } from "primeng/dom";
import { CustomizedTable } from "./avano-table.component";

/* eslint-disable prefer-const */
function onColumnResizeEnd() {
  /**
   * Changes to original:
   * - deltaCorrection: allowes moving resizer "too far" left
   * - - instead of cancelling resize, it now DOES the resize, but to min-width instead
   * - case columnResizeMode = 'expand'
   * - - 1)has some logic to search for th.last-resizable which serves as a "buffer"
   * - - - the table-width does not get changed if the .last-resizable has some buffer(shrinkPotential) left
   * - - 2)now sets table.width instead of table.minWidth
   */
  let delta = this.resizeHelperViewChild.nativeElement.offsetLeft - this.lastResizerHelperX;
  let columnWidth = this.resizeColumnElement.offsetWidth;
  let newColumnWidth = columnWidth + delta;
  let minWidth = this.resizeColumnElement.style.minWidth || 15;

  let deltaCorrection = newColumnWidth < parseInt(minWidth) ? parseInt(minWidth) - newColumnWidth : 0;
  if (deltaCorrection > 0) {
    delta += deltaCorrection;
    newColumnWidth += deltaCorrection;
  }

  if (delta !== 0) {
      if (this.columnResizeMode === 'fit') {
          let nextColumn = this.resizeColumnElement.nextElementSibling;
          let nextColumnWidth = nextColumn.offsetWidth - delta;
          if (newColumnWidth > 15 && nextColumnWidth > 15) {
              if (!this.scrollable) {
                  this.resizeColumnElement.style.width = newColumnWidth + 'px';
                  if (nextColumn) {
                      nextColumn.style.width = nextColumnWidth + 'px';
                  }
              }
              else {
                  this.resizeTableCells(newColumnWidth, nextColumnWidth);
              }
          }
      }
      else if (this.columnResizeMode === 'expand') {
        let flexElement = DomHandler.findSingle(this.tableViewChild.nativeElement, 'th.last-resizable');
        if (flexElement && flexElement.style.minWidth) {
          const shrinkPotential = flexElement.offsetWidth - flexElement.style.minWidth.replace('px', '');
          if (shrinkPotential > 0) {
            delta = Math.max(delta - shrinkPotential, 0);
          }
        }
          let tableWidth = this.tableViewChild.nativeElement.offsetWidth + delta;
          if (!this.scrollable) {
            this.resizeColumnElement.style.width = newColumnWidth + 'px';
            this.tableViewChild.nativeElement.style.width = tableWidth + 'px';
          } else {
            this.resizeTableCells(newColumnWidth, null);
            this.tableViewChild.nativeElement.style.width = tableWidth + 'px';
          }
      }
      this.onColResize.emit({
          element: this.resizeColumnElement,
          delta: delta
      });
      if (this.isStateful()) {
          this.saveState();
      }
  }
  this.resizeHelperViewChild.nativeElement.style.display = 'none';
  DomHandler.removeClass(this.containerViewChild.nativeElement, 'p-unselectable-text');
}

function resizeTableCellsOverwrite(newColWidth, nextColWidth) {
  /**
   * Basically removes the "!important" from styles written by original method, because we have more !important styles
   */
  this._resizeTableCellsOriginal(newColWidth, nextColWidth);
  const flexStylings = this.styleElement.innerHTML;
  this.styleElement.innerHTML = flexStylings.replaceAll('!important;', ';')
}

function restoreColumnWidthsOverwrite() {
  /**
   * - for 'expand', now only sets table-width to 100% instead of table-width + table-minWidth + wrapper-width
   * - for tr>th and tr>td, now sets flex-shrink to 1 from 0
   */
  if (this.columnWidthsState) {
    let widths = this.columnWidthsState.split(',');
    if (this.columnResizeMode === 'expand' && this.tableWidthState) {
        this.tableViewChild.nativeElement.style.width = "100%";
    }
    this.createStyleElement();
    if (this.scrollable && widths && widths.length > 0) {
        let innerHTML = '';
        widths.forEach((width, index) => {
            innerHTML += `
                    #${this.id} .p-datatable-thead > tr > th:nth-child(${index + 1}),
                    #${this.id} .p-datatable-tbody > tr > td:nth-child(${index + 1}) {
                        flex: 0 1 ${width}px;
                    }
                `;
        });
        this.styleElement.innerHTML = innerHTML;
    }
    else {
        DomHandler.find(this.tableViewChild.nativeElement, '.p-datatable-thead > tr > th').forEach((header, index) => {
            header.style.width = widths[index] + 'px';
        });
    }
  }
}
function saveStateWithoutSelection(this: CustomizedTable) {
    const selection = this.selection;
    this.selection = null;
    this._defaultSaveState();
    this.selection = selection;
}

function restoreStateBugfixed() {
  // see comment below for what got fixed
        const storage = this.getStorage();
        const stateString = storage.getItem(this.stateKey);
        const dateFormat = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/;
        const reviver = function (key, value) {
            if (typeof value === "string" && dateFormat.test(value)) {
                return new Date(value);
            }
            return value;
        };
        if (stateString) {
            let state = JSON.parse(stateString, reviver);
            if (this.paginator) {
                if (state.first !== undefined) { // original checks "this.first !== undefined" which is rubbish
                    this.first = state.first;
                    this.firstChange.emit(this.first);
                }
                if (state.rows !== undefined) { // original checks "this.rows !== undefined" which is rubbish
                    this.rows = state.rows;
                    this.rowsChange.emit(this.rows);
                }
            }
            if (state.sortField) {
                this.restoringSort = true;
                this._sortField = state.sortField;
                this._sortOrder = state.sortOrder;
            }
            if (state.multiSortMeta) {
                this.restoringSort = true;
                this._multiSortMeta = state.multiSortMeta;
            }
            if (state.filters) {
                this.restoringFilter = true;
                this.filters = state.filters;
            }
            if (this.resizableColumns) {
                this.columnWidthsState = state.columnWidths;
                this.tableWidthState = state.tableWidth;
            }
            if (state.expandedRowKeys) {
                this.expandedRowKeys = state.expandedRowKeys;
            }
            this.stateRestored = true;
            this.onStateRestore.emit(state);
        }
    }

/* eslint-enable prefer-const */

export { onColumnResizeEnd, resizeTableCellsOverwrite, restoreColumnWidthsOverwrite, restoreStateBugfixed, saveStateWithoutSelection };

